const WhySignUp = {
  parts: [
    'container',
    'title',
    'checkCircleContainer',
    'checkCircleItem',
    'checkCircleIcon',
    'description'
  ],
  baseStyle: {
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: 4.5,
      mt: 8,
      pt: 8,
      px: {base: 7.5, md: 8},
      pb: 10.25,
      bg: 'brandColors.secondaryBGTranslucent15',
    },
    title: {
      color: 'brandColors.greyscale90',
      fontSize: 'lg',
      fontStyle: 'normal',
      fontWeight: 'medium',
      lineHeight: '120%',
    },
    checkCircleContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
    },
    checkCircleItem: {
      display: 'flex',
      gap: 2.5,
    },
    checkCircleIcon: {
      flex: '0 0 19px',
      width: 4.75,
      height: 4.75,
      color: 'brandColors.primaryDarkLinen',
    },
    description: {
      color: 'brandColors.greyscale90',
      fontSize: 'sm',
      fontStyle: 'normal',
      fontWeight: 'normal',
      lineHeight: '140%',
    },
  },
};

export default WhySignUp;
